import axios from '../axios'

/* 
 * 价格管理
 */
//查询
export const getListApi = (params) => {
  return axios({
      url: '/exam/price/list',
      method: 'get',
      params
  })
}

//更新
export const updateApi = data => {
  return axios({
      url: 'exam/price',
      method: 'put',
      data
  })
}



// WEBPACK FOOTER //
// ./src/http/api/price.js